<template>
  <Layout>
    <div class="container openapp">
      <div style="padding: 20px">
        <div class="btn btn-main mr-3" @click="open1">Open 1</div>
        <div class="btn btn-main" @click="open2">Open 2</div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../views/layouts/Index.vue';
export default {
  components: { Layout },
  methods: {
    open1() {
      window.location.replace(
        'https://play.google.com/store/apps/details?id=com.ddtekno.masjed'
      );
    },
    open2() {
      window.location.replace(
        'intent://scan/#Intent;scheme=app package=com.ddtekno.masjed'
      );
    },
  },
};
</script>

<style></style>
